var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("div", [
        _c("div", { staticClass: "vacancies" }, [
          _c("div", { staticClass: "vacanciesHeader" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "vacanciesTabs" }, [
              _c(
                "ul",
                [
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: _vm.tab_region == "all" ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.update("all", _vm.tab_placement)
                          }
                        }
                      },
                      [_vm._v("All")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.regions, function(region, key) {
                    return _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.tab_region == key ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.update(key, _vm.tab_placement)
                            }
                          }
                        },
                        [_vm._v(_vm._s(region))]
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                [
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: _vm.tab_placement == "all" ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.update(_vm.tab_region, "all")
                          }
                        }
                      },
                      [_vm._v("All")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.placement_types, function(placement, key) {
                    return _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.tab_placement == key ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.update(_vm.tab_region, key)
                            }
                          }
                        },
                        [_vm._v(_vm._s(placement))]
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vacanciesSelect" }, [
              _c("div", { staticClass: "selectWrap" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tab_region,
                        expression: "tab_region"
                      }
                    ],
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.tab_region = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.update(_vm.tab_region, _vm.tab_placement)
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "all" } }, [_vm._v("All")]),
                    _vm._v(" "),
                    _vm._l(_vm.regions, function(region, key) {
                      return _c("option", { domProps: { value: key } }, [
                        _vm._v(_vm._s(region))
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "selectWrap" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tab_placement,
                        expression: "tab_placement"
                      }
                    ],
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.tab_placement = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.update(_vm.tab_region, _vm.tab_placement)
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "all" } }, [_vm._v("All")]),
                    _vm._v(" "),
                    _vm._l(_vm.placement_types, function(placement, key) {
                      return _c("option", { domProps: { value: key } }, [
                        _vm._v(_vm._s(placement))
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "vacanciesBody" }, [
            !_vm.loading
              ? _c("div", [
                  _vm.vacancies.length > 0
                    ? _c(
                        "div",
                        { staticClass: "vacanciesOutput" },
                        _vm._l(_vm.vacancies, function(vacancy) {
                          return _c(
                            "a",
                            {
                              staticClass: "vacancy",
                              attrs: {
                                href: vacancy.fields.url[0],
                                target: "_blank"
                              }
                            },
                            [
                              _c("h5", [
                                _vm._v(_vm._s(vacancy.fields.job_title[0]))
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(vacancy.fields.location[0]))
                              ]),
                              _vm._v(" "),
                              _c("i", { staticClass: "far fa-arrow-right" })
                            ]
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "noVacancies" }, [
                        _vm._v(
                          "\n                    No vacancies found\n                "
                        )
                      ])
                ])
              : _c("div", { staticClass: "loader" }, [
                  _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
                ])
          ])
        ])
      ])
    : _c("div", { staticClass: "loader" }, [
        _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vacanciesHeading" }, [
      _c("h3", [_vm._v("Current")]),
      _vm._v(" "),
      _c("h3", { staticClass: "boldHeading" }, [_vm._v("Vacancies")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }